import React, { useCallback } from 'react';
import "../../styles/search/view_collection.css";
import { useEffect, useState } from "react";
import { firebaseFirestore } from "../firebase/firebase_configuration";
import { doc, onSnapshot } from "firebase/firestore";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getItem } from "../repositories/movies_and_tvseries";
import { useSearchContext } from "../chats/searchContext";

import noImage from "../../images/collections/no_image.png";

const ViewCollection = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const {getUserId} = useSearchContext();
    const [getCollectionName, setCollectionName] = useState("");
    const [getCollectionDescription, setCollectionDescription] = useState("");
    const [getCollectionItems, setCollectionItems] = useState([]);

    const path = location.pathname.split("/");
    const collectionId = path[path.indexOf("collections") + 1];
    const username = path[path.indexOf("search") + 1]

    const goBack = () => {
        navigate(-1);
    };

    const getCollection = useCallback(async () => {
        try {
            const userRef = doc(firebaseFirestore, 'User Collections', getUserId);
            const scription = onSnapshot(userRef, async (docSnapshot) => {
                if (docSnapshot.exists()) {
                    const collectionsData = docSnapshot.data();
                    let collectionsArray = [];
                    Object.keys(collectionsData).forEach((fieldName) => {
                        if (fieldName === collectionId) {
                            const collection = collectionsData[fieldName];
                            setCollectionName(collection.name);
                            setCollectionDescription(collection.description);
                            collectionsArray = collection.items;
                        };
                    });

                    const itemDetails = await Promise.all(
                        collectionsArray.map(async (item) => {
                            let newGenreList = [];
                            const itemId = item.split("_")[1];
                            const type = item.split("_")[0];
                            const details = await getItem({ itemId, type: type === "movie" ? type : "tv" });

                            details["genres"].forEach((result) => {
                                const isDuplicate = newGenreList.some(item => item.name === result.name);
                                if (!isDuplicate) {
                                    newGenreList.push({
                                        name: result.name,
                                    });
                                }
                            });
                            const genreNames = newGenreList.map(item => item.name);

                            return { 
                                ...item, 
                                id: itemId,
                                name: `${type === "movie" ? details.title : details.name}`,
                                image: details.poster_path,
                                type: type,
                                genre: `${genreNames[0] === "" || genreNames[0] == null ? "action" : genreNames[0].toLowerCase()}` 
                            };
                        })
                    );

                    setCollectionItems(itemDetails);
                };
            }); 

            return () => scription;
        } catch (error) {
            console.log(error.message); 
        };
    }, [getUserId, collectionId]);

    const getCardSpace = useCallback(() => {
        if (getCollectionItems.length > 0) {
            const parent = document.getElementById('collection_details_screen_grid');
            const parentWidth = parent.offsetWidth;
            const childWidth = window.innerWidth <= 600 ? 110 : 150 + 30;
            const numChildren = Math.floor(parentWidth / childWidth);
            parent.style.gridTemplateColumns = `repeat(${numChildren}, 1fr)`;
        }
    }, [getCollectionItems]);

    useEffect(() => {
        getCardSpace();
        const handleResize = () => {
            getCardSpace();
        };
    
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [getCardSpace]);

    useEffect(() => {
        getCollection();
    }, [getCollection]);

    useEffect(() => {
        if (getUserId === "" || getUserId === null) {
            navigate("/main_back/search", {replace: true});
        }
    }, [getUserId, navigate]);

    return(
        <div className="search_view_collection_screen">
            <div className="collection_details_screen_header_row">
                <p className="collection_details_screen_header">{`${username.charAt(0).toUpperCase()}${username.slice(1)}'s Collection: ${getCollectionName}`}</p>
                <p onClick={goBack} className="home_view_item_back">back</p>
            </div>

            <div className="collection_details_screen_block">
                <p className="collection_details_screen_description">{getCollectionDescription}</p>

                {
                    getCollectionItems.length > 0
                    ? <div id="collection_details_screen_grid" className="collection_details_screen_grid">
                        {
                            getCollectionItems.map((item, index) => (
                                <div className="collection_details_screen_item_column">
                                    <Link className="action_container_sub_home_screen_a" to={`/main_back/home/${item.genre}/${item.type}/${item.id}`}><div key={index} id="movie_item" className="movie_item">
                                        <img
                                            src={item.image === "" || item.image == null ? noImage : `https://image.tmdb.org/t/p/w500${item.image}`}
                                            alt={item.name}
                                            className="movie_poster"
                                        />
                                        <p className="movie_item_p">{item.name}</p>
                                    </div></Link>
                                </div>
                            ))                        
                        }
                    </div>
                    : <p className="collection_details_screen_empty_text">This collection is empty 🥲.</p>
                }
            </div>
        </div>
    );
};

export default ViewCollection;